import { createFileRoute } from "@tanstack/react-router";

import McpPage from "./-components/McpPage";

export const Route = createFileRoute("/_app/_dashboard/integrations/mcp")({
  component: McpPage,
});
